'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pathToRegistrations = function pathToRegistrations(pid, fid) {
  return ['events', 'persons', pid, 'feiseanna', fid, 'registered'];
};

var feisRegistrationsForPersonUrl = exports.feisRegistrationsForPersonUrl = function feisRegistrationsForPersonUrl(fid, pid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/registrations/' + pid;
};

var registrationsForPersonAreLoading = exports.registrationsForPersonAreLoading = function registrationsForPersonAreLoading(state, fid, pid) {
  return state.getIn(pathToRegistrations(pid, fid).concat(['loading'])) || !state.getIn(pathToRegistrations(pid, fid));
};

var getRegistrationsForPerson = exports.getRegistrationsForPerson = function getRegistrationsForPerson(state, fid, pid) {
  return state.getIn(pathToRegistrations(pid, fid));
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/registrations/paths.js
// module id = 67
// module chunks = 0